import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { environment } from '../../environments/environment';
import { IChurch, ILiveBroadcast } from './interfaces';

@Injectable()
export class CurchService {

  public churches$: BehaviorSubject<IChurch[]> = new BehaviorSubject([]);
  public liveBroadcast$: BehaviorSubject<ILiveBroadcast[]> = new BehaviorSubject([]);

  constructor(private http: Http) { }

  selectChurchesAllFetch() {
    return this.churches$.asObservable();
  }

  selectLiveBroadcasts() {
    return this.liveBroadcast$.asObservable();
  }

  dispatchChurchesAllFetch(page: number = 1, pageSize: number = 1000): void {
    const url = environment.endPoint + `churches?page=${page}&page_size=${pageSize}`;

    this.http.get(url)
      .subscribe((response) => {
        const payload = <IChurch[]>response.json();
        this.churches$.next(payload);
      });
  }

  dispatchLiveBroadcastAllFetch(page: number = 1, pageSize: number = 1000): void {
    const url = environment.endPoint + `churches/live?page=${page}&page_size=${pageSize}`;

    this.http.get(url)
      .subscribe((response) => {
        const payload = <ILiveBroadcast[]>response.json();
        this.liveBroadcast$.next(payload);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/providers/church.service.ts